import { DialogType } from 'app/components/composite/StatusDialog';

export enum SnackbarVariant {
    DEFAULT = 'variant-default',
    SUCCESS = 'variant-success',
    WARNING = 'variant-warning',
    ERROR = 'variant-error'
}

export const MapSnackbarVariantToDialogType = {
    [SnackbarVariant.ERROR]: DialogType.ERROR,
    [SnackbarVariant.WARNING]: DialogType.WARNING,
    [SnackbarVariant.DEFAULT]: DialogType.INFO,
    [SnackbarVariant.SUCCESS]: DialogType.INFO
};
